import React from 'react';
import { PortalUnidadesList } from '../../components/propietario/PortalUnidadesList';

export default function PropietarioExpensas() {
  return (
    <PortalUnidadesList
      basePath="/propietario/expensas"
      titulo="Expensas"
      descripcion="Detalle y estado de cuenta de expensas por unidad."
    />
  );
}
